// extracted by mini-css-extract-plugin
export default {"wrapper":"ArYef","option":"nmrR_","option2":"uSvUI","radio":"htkkm","label":"lRUO9","disabled":"PEOTB","labelText":"so2Xm"};